import { render } from "./SolutionList.vue?vue&type=template&id=d127da56&scoped=true"
import script from "./SolutionList.vue?vue&type=script&lang=js"
export * from "./SolutionList.vue?vue&type=script&lang=js"

import "./SolutionList.vue?vue&type=style&index=0&id=d127da56&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d127da56"],['__file',"src/views/qywx/ai/quotation/SolutionList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d127da56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d127da56', __exports__)) {
    api.reload('d127da56', __exports__)
  }
  
  module.hot.accept("./SolutionList.vue?vue&type=template&id=d127da56&scoped=true", () => {
    api.rerender('d127da56', render)
  })

}


export default __exports__